exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.fa.fa-commenting{font-size:30px}", ""]);

// exports
